const featuredTestimonialSlider = document.querySelector('.ft-slider .ft-slides');

$(window).on('load', function() {
	"use strict";
    if(featuredTestimonialSlider){
        $(featuredTestimonialSlider).slick({
            infinite: false,
            slide: '.ft-slide',
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
});